const { useContext } = require("react");
const { CallContext } = require("src/context/CallContext");
export const useCall = () => useContext(CallContext);
